var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 17.3333C6.78921 17.3333 4.6696 16.4553 3.10679 14.8925C1.54399 13.3297 0.666016 11.2101 0.666016 8.99996C0.666016 6.78982 1.54399 4.67021 3.10679 3.1074C4.6696 1.5446 6.78921 0.666627 8.99935 0.666627C10.6482 0.66566 12.2604 1.15388 13.6317 2.06949C15.003 2.9851 16.0718 4.28695 16.703 5.81027C17.3341 7.33359 17.4991 9.0099 17.1772 10.6271C16.8552 12.2442 16.0608 13.7295 14.8943 14.895C14.1218 15.671 13.203 16.2861 12.1911 16.7046C11.1792 17.1232 10.0944 17.3369 8.99935 17.3333ZM8.70768 4.77496C8.54199 4.77518 8.38315 4.8411 8.26598 4.95826C8.14882 5.07543 8.0829 5.23427 8.08268 5.39996V9.60829C8.08339 9.7163 8.11219 9.82227 8.16625 9.91578C8.22031 10.0093 8.29777 10.0871 8.39102 10.1416L11.6577 12.0916C11.7557 12.1512 11.868 12.1831 11.9827 12.1841C12.0908 12.1834 12.1968 12.1545 12.2904 12.1003C12.3839 12.0461 12.4617 11.9684 12.516 11.875C12.6 11.7321 12.6244 11.562 12.5838 11.4013C12.5433 11.2407 12.4411 11.1025 12.2993 11.0166L9.33268 9.24996V5.39996C9.33246 5.23427 9.26654 5.07543 9.14938 4.95826C9.03222 4.8411 8.87337 4.77518 8.70768 4.77496Z",
    fill: "#71859E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b1a7e6d6b7a7aaecbf244eedca635339.svg";
export { ForwardRef as ReactComponent };